export const localeCurrency = (value = 0, locale = 'es-ES', currency: string): string => {
  const formatter = new Intl.NumberFormat(locale, {style: 'currency', currency});

  return formatter.format(value);
};
